import React from "react";

import { Icon, IconProps } from "../";

export const ViewOnIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.87399 6.56312C6.67933 4.96696 9.19358 3.75 12 3.75C14.8064 3.75 17.3206 4.96696 19.1259 6.56312C20.9034 8.1347 22.125 10.1974 22.125 12C22.125 13.8026 20.9034 15.8653 19.1259 17.4369C17.3206 19.033 14.8064 20.25 12 20.25C9.19357 20.25 6.67945 19.033 4.87419 17.4369C3.09672 15.8653 1.87517 13.8026 1.875 12.0001C1.87483 10.1974 3.09647 8.13469 4.87399 6.56312ZM6.5 12C6.5 8.96243 8.96243 6.5 12 6.5C15.0376 6.5 17.5 8.96243 17.5 12C17.5 15.0376 15.0376 17.5 12 17.5C8.96243 17.5 6.5 15.0376 6.5 12ZM8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12Z"
      />
    </Icon>
  );
};
